import script from "./consultBox.vue?vue&type=script&setup=true&lang=js"
export * from "./consultBox.vue?vue&type=script&setup=true&lang=js"

import "./consultBox.vue?vue&type=style&index=0&id=4ce357d6&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce357d6"]])

export default __exports__